module.exports = __webpack_public_path__ + "img/VL_06_03.a6070bf3.png";